<template><div><h1 id="auswertungen-projektfinanzierung" tabindex="-1"><a class="header-anchor" href="#auswertungen-projektfinanzierung"><span>Auswertungen Projektfinanzierung</span></a></h1>
<p>Die Referenz beschreibt Auswertungen und Statistiken aus dem Bereich Projektfinanzierung.</p>
<p><strong>Inhaltsverzeichnis</strong></p>
<p><RouteLink to="/referenz/refstat/ft.refstat.projaktionausw.html">Aktionsauswertung Projekte</RouteLink> - Aktionsauswertung nach Projekten und Projektgruppen</p>
<p><RouteLink to="/referenz/refstat/ft.refstat.finanziereraktionausw.html">Aktionsauswertung Projektfinanzierer</RouteLink> - Aktionsauswertung mit Gruppierung nach Projektfinanzierer</p>
</div></template>


